import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      const f = window as any
      const b = document
      const e = 'script'
      const v = 'https://connect.facebook.net/en_US/fbevents.js'

      let n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })

      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v

      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        // Fallback: append to head if no script tags exist
        b.head.appendChild(t)
      }

      // Initialize pixel
      window.fbq('init', pixelId)

      // Track PageView
      window.fbq('track', 'PageView')
    }
  }, [pixelId])

  const trackAddToCart = (value?: number, currency: string = 'UYU') => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        value: value,
        currency: currency,
      })
    }
  }

  return { trackAddToCart }
}
